// extracted by mini-css-extract-plugin
export default {"readButton":"styles_readButton__HuExD"};